var option_webview_default = {
  "option": "YPIbo",
  "user_choice": "nGC70",
  "check": "pcGbo",
  "image": "-JBEB",
  "input": "gy4JO",
  "title": "_7RLSR",
  "centered": "l3avP",
  "with_result": "N-XTg",
  "list": "_6a0nL",
  "with_image": "sW5MH",
  "progress": "nzP2K",
  "progress_value": "HlL6z",
  "label": "txWl2",
  "cta": "ZUuYC",
  "adornment_icon": "eSxXQ",
  "remove": "m5JjM",
  "removeButton": "t8PPa",
  "removeButtonIcon": "_4Lbko",
  "overlay": "PKs3p",
  "shown": "h81lt",
  "dark": "cseEb",
  "spinner": "hud-W",
  "spin": "GpVti",
  "grid": "_9AV0E"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
